import { useAnalyticsEvents, fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';

import type { Flow } from '../constants.tsx';
import { useIsCrossFlowEligible, useIsCoUseEligible } from '../utils.tsx';

type experimentEligibilty = {
	flow: Flow;
	isVariantEligible: boolean;
};

export const useIsExperimentEligible = (skipExposure: boolean): experimentEligibilty => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const crossFlowEligible = useIsCrossFlowEligible();
	const coUseEligible = useIsCoUseEligible();

	let isVariantEligible = false;
	let flow: Flow = 'none';

	if ((crossFlowEligible || coUseEligible) && !skipExposure) {
		fireTrackAnalytics(createAnalyticsEvent({}), 'backlogButtonRefresh exposed');
		flow = crossFlowEligible ? 'crossFlow' : 'coUse';
		isVariantEligible = true;
	}

	return { flow, isVariantEligible };
};
